export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortOrder: string;
  filter:{
    searchText:string
    status:number
    cptGrpId?:number
  }
};

export type MasterTableDataType = {
       cptId: number;
       cptClinicId: number;
       cptCode: string;
       cptCreatedByDate: string; // ISO date string format
       cptCreatedById: number;
       cptDes: string;
       cptName: string;
       cptRate: number;
       cptStatus: number;
       lonicCode: string | null;
       lonicUnit: string | null;
       lonicValue: number | null;
       needLonicCode: boolean;
       cptGroupId: number;
       cptGroupName:string;
       cptType: number;
       cptPoId: number | null;
       isPackage: boolean;
       specimenId: number | null;
       packageRate?:number
};


export type MasterDataType = {
  cptId: number|null;
  cptGroupId: number;
  cptCode: string;
  cptName: string;
  cptStatus: number;
  cptRate: number;
  cptDes: string;
  needLonicCode: boolean;
  isPackage: boolean;
  lonicCode: string;
  lonicValue: number;
  lonicUnit: string;
  cptCreatedById: number;
  cptClinicId: number|null;
  cptType: number|null;
  cptPoId: number;
  specimenId: number|null
};








export type SaveResponseType = {};

export type MasterFormDataType = {
  cptCode: string;
  cptName: string;
  cptGroupName:{cptGroupId:number,cptGroupName:string}|null
  rate:number|string;
  description:string;
  isPackage:boolean;
  needLonicCode:boolean
  status:number
};

export const initialFormData: MasterFormDataType = {
  cptCode: "",
  cptName: "",
  cptGroupName:null,
  rate:"",
  description:"",
  isPackage:false,
  needLonicCode:false,
  status: 1
};
